module.exports = "## Optimizing is no longer optional\r\n\r\nIf your pages load slow, it is probably caused by uncompressed images. The problem is grave enough for Google to use page load time as a ranking factor now. \r\n\r\nOptimizing your images properly lower your load time, reduce bounce rate, and save both your and customer’s data costs. So there is really no reason to upload an image to your website without optimizing it!"


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/PhotoCompress/photo-compress-section-one.md
// module id = 1159
// module chunks = 0